module.exports = __webpack_public_path__ + "img/banner-responsible-consumption-and-production.025159ef.png";